export default __webpack_public_path__ + "static/media/bg_smll_02.3de8a462.png";